package er.prateek.crossly.share

/** Live clock in the puzzle chrome: `MM:SS`, or `H:MM:SS` after an hour. */
fun formatClock(elapsedMs: Long): String {
    val totalSec = (elapsedMs / 1000L).coerceAtLeast(0L)
    val hours = totalSec / 3600L
    val minutes = (totalSec % 3600L) / 60L
    val seconds = totalSec % 60L
    val mm = minutes.toString().padStart(2, '0')
    val ss = seconds.toString().padStart(2, '0')
    return if (hours > 0) "$hours:$mm:$ss" else "$mm:$ss"
}

/**
 * Spoken duration for challenge copy: `50 Seconds` under a minute, otherwise
 * `5 Mins 50 Seconds`.
 */
fun formatSpokenDuration(elapsedMs: Long): String {
    val totalSec = (elapsedMs / 1000L).coerceAtLeast(0L)
    if (totalSec < 60L) {
        return if (totalSec == 1L) "1 Second" else "$totalSec Seconds"
    }
    val mins = totalSec / 60L
    val secs = totalSec % 60L
    val minPart = if (mins == 1L) "1 Min" else "$mins Mins"
    if (secs == 0L) return minPart
    val secPart = if (secs == 1L) "1 Second" else "$secs Seconds"
    return "$minPart $secPart"
}

fun challengeWon(elapsedMs: Long, challengerTimeMs: Long): Boolean =
    challengerTimeMs > 0L && elapsedMs < challengerTimeMs

fun timeMarginMs(fasterMs: Long, slowerMs: Long): Long =
    (slowerMs - fasterMs).coerceAtLeast(0L)
